import { render, staticRenderFns } from "./storedValueMoney.vue?vue&type=template&id=5da35398&scoped=true&"
import script from "./storedValueMoney.vue?vue&type=script&lang=js&"
export * from "./storedValueMoney.vue?vue&type=script&lang=js&"
import style0 from "./storedValueMoney.vue?vue&type=style&index=0&id=5da35398&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da35398",
  null
  
)

export default component.exports